<template>
  <section>
    <div class="container">
      <div class="grid row">
        <div class="g-col-12">
          <post-grid :posts="posts" class_name="archive-index-grid"></post-grid>
        </div>
        <div class="g-col-12">
          <button
            class="btn"
            @click="getLoadMorePosts"
            v-if="page !== totalpages"
          >
            load more
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { ref, reactive } from "vue";
import PostGrid from "./PostGrid.vue";

export default {
  components: {
    PostGrid,
  },
  props: ["searchfor", "taxonomy", "term"],
  setup(props) {
    let posts = reactive({ list: [] });
    let search = props.searchfor;
    let taxonomy = props.taxonomy;
    let term = props.term;
    let page = ref(0);
    let totalpages = ref(-1);
    let ppp = 3;
    let query;

    /**
     * Fetch
     */
    function getData(url) {
      return new Promise((resolve, reject) => {
        fetch(url)
          .then((response) => {
            return response.json();
          })
          .then((data) => resolve(data))
          .catch((error) => reject(error));
      });
    }

    /**
     * Initial call: get posts
     */
    if (taxonomy && term) {
      query = `taxonomy=${taxonomy}&term=${term}`;
    } else if (search) {
      query = `searchfor=${search}`;
    }

    getData(
      `/wp-json/api/archive-posts/?${query}&ppp=${ppp}&page=${page.value+1}`
    ).then((data) => {
      console.log(data.results);
      page.value++;
      totalpages.value = data.results.totalpages;
      posts.list = data.results.posts;
    });

    /**
     * get posts by load more button
     */
    const getLoadMorePosts = () => {
      getData(
        `/wp-json/api/archive-posts/?${query}&ppp=${ppp}&page=${page.value+1}`
      ).then((data) => {
        page.value++;
        posts.list = posts.list.concat(data.results.posts);
      });
    };

    return { posts, page, totalpages, getLoadMorePosts };
  },
};
</script>
